<script setup lang="ts">
interface Props {
  activeFilterCount?: number
}

defineProps<Props>();
</script>

<template>
  <v-card-outlined variant="outlined">
    <v-card-title class="border-b">
      Filters
    </v-card-title>
    <v-card-text>
      <slot/>
    </v-card-text>
    <v-card-actions>
      <v-btn
        block
        color="primary"
        variant="tonal"
        :disabled="!activeFilterCount || activeFilterCount === 0"
        @click="$emit('reset-filters')"
        data-pw="resetFiltersButton"
      >
        Reset Filters
      </v-btn>
    </v-card-actions>
  </v-card-outlined>
</template>

<style scoped>

</style>
